export default {
  masterPayer: [],
  obEngineers: [],
  onboardingAccounts: [],
  loadingRequest: false,
  accountHeaders: [
    {
      sortable: true,
      text: 'ID',
      value: 'Onboarding_Id',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Onboarding Status',
      value: 'Onboarding_Status',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Opportunity ID',
      value: 'OppReg_Id',
      align: 'left'
    },
    // {
    //   sortable: true,
    //   text: 'ACE Opportunity Number',
    //   value: 'Opportunity_Number',
    //   align: 'left'
    // },
    {
      sortable: true,
      text: 'Workload Status',
      value: 'Workload_Status',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Requestor',
      value: 'Requestor',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Date Requested',
      value: 'Date_Requested',
      align: 'left'
    },
    {
      sortable: true,
      text: 'AWS Request Type',
      value: 'AWS_Req_Type',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Type of Request',
      value: 'Request_Type',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Engineer Assigned',
      value: 'Engr_Assigned_To',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Customer Name',
      value: 'Customer_Name',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Calculated Master Payer',
      value: 'Calculated_Master_Payer',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Calculated Account Name',
      value: 'Acct_name',
      align: 'left'
    },
    {
      sortable: true,
      text: 'WBS',
      value: 'WBS_code',
      align: 'left'
    },
    {
      sortable: true,
      text: 'IWO',
      value: 'IWO_code',
      align: 'left'
    },
    {
      sortable: true,
      text: 'AWS Credits',
      value: 'AWS_Credits',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Account Owners',
      value: 'Account_Owners',
      align: 'left'
    },
    {
      sortable: true,
      text: 'IAM Users',
      value: 'IAM_Users',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Notification',
      value: 'Notification',
      align: 'left'
    },
    // {
    //   sortable: true,
    //   text: 'CloudCheckr Users',
    //   value: 'CloudCheckr_Users',
    //   align: 'left'
    // },
    {
      sortable: true,
      text: 'Financial Owners',
      value: 'Financial_Owner',
      align: 'left'

    },
    {
      sortable: true,
      text: 'Restricted',
      value: 'Acct_Restricted',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Region',
      value: 'Specific_Region',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Location Specific',
      value: 'Specific_Location',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Account Purpose/Primary Use',
      value: 'Account_Purpose',
      align: 'left'
    },
    {
      sortable: true,
      text: 'AWS Support Type',
      value: 'AWS_Support_Type',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Managed Service Type',
      value: 'Managed Service Type',
      align: 'left'
    },
    {
      sortable: true,
      text: 'SaaS',
      value: 'SaaS',
      align: 'left'
    },
    {
      sortable: true,
      text: 'Business Use',
      value: 'Business_Use',
      align: 'left'
    },
    {
      sortable: true,
      text: 'GovCloud Resource Account',
      value: 'GovCloud_Resource_Account',
      align: 'left'
    }
  ],
  viewRequests: {
    searchByCustomerError: null,
    searchByCustomerMessage: '',
    searchingByCustomer: false,
    searchByRequestorError: null,
    searchByRequestorMessage: '',
    searchingByRequestor: false
  },
  processNewAccount: {
    loadingData: false
  },
  isCreateObEngr: false,
  showEngrDialog: {
    message: null
  },
  createObEngr: {
    Id: null,
    Name: null,
    Email: null
  },
  showStatuses: {
    Workload_Status: null,
    AWS_Support_Type: null,
    WS_Selected: null
  },
  existingOnboardingAccount: {
    AWS_Req_type: null, 
    AWS_Support_Type: null, 
    Account_Owners: [], 
    Account_Purpose: null, 
    AcctSecurity_Id: null, 
    Acct_Alias_Group: null, 
    Acct_DL: null, 
    Acct_Description: null, 
    Acct_Exp_Id: null, 
    Acct_ID: null, 
    Acct_Offering_Stat: null, 
    Acct_Restricted: null, 
    Acct_name: null, 
    Acct_status: null, 
    Additional_Acct: null, 
    Business_Use: null, 
    Calculated_Master_Payer: null, 
    Client_Shortname: null, 
    CloudCheckr_users: null, 
    Comments: null, 
    Contact_Id: null, 
    Cust_Shortname: null, 
    Customer_Id: null, 
    Customer_Regulations: null, 
    Customer_Type: null, 
    DateMarkedAsUnknown: null, 
    Date_Requested: null, 
    Date_Requested_change: null, 
    Date_Suspended: null, 
    Date_onboarded: null, 
    Del_Flag: null, 
    Engr_Assigned_To: null,
    Ext_Account_Id: null, 
    Financial_Discount_Id: null, 
    Financial_Id: null, 
    // Financial_Owner: [], 
    // IAM_Users: [], 
    Invoice_DL: null, 
    Is_MP: null, 
    Last_Date_Validated: null, 
    MP_ID: null, 
    Managed_Svc: null, 
    // Notification_List: [], 
    OBS_Date_Updated: null, 
    Onboard_Date_Lock: null, 
    Onboarding_Id: null, 
    Onboarding_Status: null, 
    POD_Id: null, 
    Previous_MP_ID: null, 
    Project_Id: null, 
    Registration_Id: null, 
    Request_Type: null, 
    Requestor_Id: null, 
    Restricted_Region_Id: null, 
    SaaS: null,
    SaaS_Solution: null, 
    Specific_Location: null, 
    Specific_Region: null, 
    Tmp_Cust_Name: null, 
    Unique_Agreement_Id: null,
    Validation_Type: null, 
    WS_Selected: null,
    GovCloud_Resource_Account: null
  },

  updateAccount: {
    accountId: '',
    accountIdExistError: false,
    accountIdExistErrorMessages: [],
    accountIdExistSuccess: false,
    accountIdExistSuccessMessages: [],
    accountIdExistLoading: false,
    isAccountIdExist:false,

    opportunityNumber: '',
    opportunityNumberExistError: false,
    opportunityNumberExistErrorMessages: [],
    opportunityNumberExistSuccess: false,
    opportunityNumberExistSuccessMessages: [],
    opportunityNumberExistLoading: false,
    opportunityNumberExist:false,

    searching: false,
    saving: null,
    showAlertResponse: false,
    alertType: null, // ie: error or success
    alertMessage: null,
    showDialog: false,
    customerList: [],
    AWS_Support_Type: null,
    Workload_Status: null,
    IAM_Users:[],
    Notification_List: [],
    Financial_Owner: [],
    record: {
      Onboarding_Id: null,
      Acct_name: null,
      Acct_Description: null,
      Requestor_FullName: null,
      Date_Requested: null,
      Managed_Svc: null,
      Calculated_Master_Payer: null,
      Acct_DL: null,
      Acct_ID: null,
      Acct_Alias_Group: null,
      Onboarding_Status: null,
      Date_onboarded: null,
      Acct_Restricted: null,
      Business_Use: null,
      Customer_Id: null,
      Customer_Name: null,
      Financial_Id: null,
      Aws_credits: null,
      WBS_code: null,
      IWO_code: null,
      Request_Type: null,
      Saas: null,
      MFA: 'Vault0',
      Root_Credential_Store: 'Vault0',
      Specific_Location: null,
      Specific_Region: null,
      Tmp_Cust_Name: null,
      AWS_Req_Type: null,
      AWS_Support_Type: null,
      Master_Id: null,
      MP_ID: null,
      AcctSecurity_Id: null,
      Unique_Agreement_Id: null,
      Acct_Exp_ID: null,
      Registration_Id: null,
      Account_Owners: [],
      CloudCheckr_users: [],
      IAM_Users: [],
      Notification_List: [],
      Financial_Owner: [],
      Invoice_DL: [],
      GovCloud_Resource_Account: null
    },
    loadingChangeLog: false,
    changeLogs: [],
    changeLogHeaders: [
      {
        sortable: true,
        text: 'ID',
        value: 'Log_Id',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Action',
        value: 'Action',
        align: 'left'
      },
      {
        sortable: false,
        text: 'User',
        value: 'User',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Change From',
        value: 'Change_From',
        align: 'left'
      },
      {
        sortable: false,
        text: 'Change To',
        value: 'Change_To',
        align: 'left'
      },
      {
        sortable: true,
        text: 'Created At',
        value: 'Create_Date',
        align: 'left'
      }
    ]
  },

  createAccount: {
    showDialog: false,
    creating: false,
    fields: {
      external_id: null
    }
  }
}
